import { makeStyles } from '@material-ui/core/styles';
import { isiOS } from '../../../utils/utility';
import { fontClasses } from '../../../fontStyles';

const makeStyle = makeStyles((theme) => ({
    container: {
        overflowY: 'auto',
        overflowX: 'hidden',
        // width: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '20px 20px 24px',
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        height: isiOS()
            ? 'calc(100vh - 64px - env(safe-area-inset-top) - var(--footer-height, 0px))'
            : 'calc(100vh - 64px - var(--footer-height, 0px))',
        justifyContent: 'space-between',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        overflowY: 'auto',
        paddingRight: '4px',
        '&::-webkit-scrollbar': {
            width: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
    },
    imageWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '16px 0 28px 0',
    },
    title: {
        ...fontClasses.title2,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '8px',
    },
    
    subtitle: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '8px',
    },
    serviceProviderPinBody: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '8px',
        '& strong, & b': {
            color: `${theme.palette.tertiary.headingText} !important`,
            fontWeight: 700,
        },
    },
    subtitleLight: {
        ...fontClasses.body1,
        color: `${theme.palette.secondary.subHeading} !important`,
        textAlign: 'center',
        marginTop: '8px',
    },
    numberedList: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        paddingLeft: '24px',
        margin: '8px auto 0 auto',
        listStyleType: 'decimal',
        listStylePosition: 'outside',
        '& li': {
            marginTop: '8px',
            display: 'list-item',
            listStyleType: 'auto !important',
        },      
    },
    numberedListNone:{
       '& li': {
            listStyleType: 'none !important',
        }, 
    },
    IQAirDisplayBox: {
       display:'flex',
       flexDirection:'column',
        marginTop: '16px',
        padding:'0 16px',
       
        '& $numberedList': {
             margin: '2px auto 12px auto',
        }
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        paddingTop: '16px',
        '& .MuiButton-root': {
            WebkitTapHighlightColor: 'transparent',
            '&:focus': {
                backgroundColor: 'inherit',
            },
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
        },
    },
    primaryButton: {
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        ...fontClasses.body1,
        fontWeight: '500',
        fontSize: '16px !important',
    
        '&:disabled': {
            backgroundColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            opacity: 1,
        '& span':{
         color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
        }   
        },
    },
    iqAirDisplayPrimaryButton:{
        backgroundColor:'transparent !important',
        border:'1px solid #01B5DE !important',
        color:'#01B5DE !important',
    },
    secondaryButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        ...fontClasses.body1,
        fontSize: '16px !important',
        fontWeight: '500',
    },
    textButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        background: 'transparent',
        ...fontClasses.body1,
        fontWeight: '700',
    },
    yesNoRow: {
        display: 'flex',
        gap: '12px',
        width: '100%',
    },
    yesNoButton: {
        flex: 1,
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        ...fontClasses.body1,
        fontWeight: '500',
        fontSize: '16px !important',
    },
    yesButton: {
        flex: 1,
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        ...fontClasses.body1,
        fontWeight: '700',
        fontSize: '16px !important',
    },
    // Take photo screen
    photoHintBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        backgroundColor: `${theme.palette.primary.cardBackground}`,
        borderRadius: '8px',
        padding: '16px',
        marginTop: '12px',
        gap: '12px',
    },
    photoHintText: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
        flex: 1,
        fontWeight:400,
        textAlign: 'center',
        width: '100%',
    },
    photoButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        flexShrink: 0,
        width: '100%',
    },
    takePhotoBtn: {
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton} !important`,
        borderRadius: '6px',
        padding: '6px 10px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        ...fontClasses.body2,
        fontWeight: '700',
        backgroundColor: 'transparent !important',
        flex: 1,
        textAlign: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
    capturedThumb: {
        marginTop: '18px',
        borderRadius: '8px',
        position: 'relative',
        padding: '10px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
    },
    capturedThumbRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 8px',
        backgroundColor: `${theme.palette.primary.background}`,
    },
    capturedThumbName: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText}`,
    },
    capturedThumbImg: {
        maxWidth: '100%',
        maxHeight: '50vh',
        width: 'auto',
        height: 'auto',
        display: 'block',
        margin: '0 auto',
    },
    closeThumbBtn: {
        padding: '2px',
        minWidth: 'unset',
        color: `${theme.palette.tertiary.headingText}`,
    },
    // Captured photo full display (used in terminals / connect wires screens)
    capturedPhotoFull: {
        maxWidth: '100%',
        maxHeight: '50vh',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        borderRadius: '8px',
        display: 'block',
        margin: '0 auto 12px auto',
        padding: '10px',
        cursor: 'pointer',
    },
    // Constrained photo for terminal selection (tap to expand)
    capturedPhotoConstrained: {
        maxWidth: '100%',
        maxHeight: '175px',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        borderRadius: '8px',
        display: 'block',
        margin: '0 auto 12px auto',
        padding: '4px',
        cursor: 'pointer',
        border: `1px solid ${theme.palette.primary.dashedBorderColor || '#E0E0E0'}`,
    },
    // Full-screen photo overlay (lightbox)
    photoOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: '30px',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        touchAction: 'none',
    },
    photoOverlayClose: {
        position: 'absolute',
        top: isiOS() ? 'calc(16px + env(safe-area-inset-top))' : '16px',
        right: '16px',
        width: '36px',
        height: '36px',
        minWidth: '36px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.2)',
        color: '#fff',
        fontSize: '18px',
        lineHeight: 1,
        padding: 0,
        zIndex: 10000,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.35)',
        },
    },
    photoOverlayImg: {
        maxWidth: '90%',
        maxHeight: '90%',
        objectFit: 'contain',
        borderRadius: '8px',
        transformOrigin: 'center center',
        transition: 'transform 0.05s linear',
    },
    // Terminal chips
    chipsSection: {
        marginTop: '12px',
    },
    chipGroupLabel: {
        ...fontClasses.graphLabel2,
        color: `${theme.palette.tertiary.headingText} !important`,
        fontWeight: '700',
        marginBottom: '6px',
        marginTop: '16px',
        textAlign: 'left',

    },
    chipRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    chip: {
        padding: '6px 14px',
        borderRadius: '20px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        color: `${theme.palette.tertiary.headingText}`,
        cursor: 'pointer',
        ...fontClasses.body2,
        userSelect: 'none',
    },
    chipSelected: {
        padding: '6px 14px',
        borderRadius: '20px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        color: '#fff',
        cursor: 'pointer',
        ...fontClasses.body2,
        userSelect: 'none',
    },
    showMoreBtn: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px 0',
        textAlign: 'center',
        width: '100%',
        ...fontClasses.body2,
        fontWeight: '700',
        marginTop: '4px',
    },
    // Wiring map table
    wiringTable: {
        width: '100%',
        marginTop: '12px',
    },
    wiringTableHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '28px',
        marginBottom: '16px',
    },
    wiringColLabel: {
        ...fontClasses.body2,
        textAlign: 'center',
        minWidth: '56px',
        color: `${theme.palette.secondary.subHeading} !important`,
    },
    wiringRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '30px',
        marginBottom: '16px',
    },
    wiringChipOld: {
         ...fontClasses.greySmallText,
       
        borderRadius: '18px',
        border: `1.364px solid ${theme.palette.primary.dashedBorderColor || '#ccc'}`,
        backgroundColor: theme.palette.primary.cardBackground,
        color: theme.palette.primary.mainText2,
       
        minWidth: '56px',
        textAlign: 'center',
        lineHeight:'24px'
    },
    wiringChipOldCWire: {
        border: '1px solid #01B5DE',
        color: '#01B5DE',
    },
    wiringArrow: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        flexShrink: 0,
    },
    wiringArrowDarkColor: {
        '& .wiringArrow svg path, & svg path': {
            fill: '#ffffff',
        },
        '& $wiringChipNew': {
            color: '#ffffff',
        },
    },
    wiringChipNew: {
         ...fontClasses.greySmallText,

        borderRadius: '18px',
        border: `1.364px solid #89E18A`,
        backgroundColor: theme.palette.primary.cardBackground,
        color: '#14C415',
       
        minWidth: '56px',
        textAlign: 'center',
        lineHeight:'24px'
    },
    tapeOff: {
       borderColor: '#f37320',
       color: '#f37320',
    },
    wiringChipCWire: {
        color: '#01B5DE',
        border: '1px solid #01B5DE',
    },
    cWireNoteRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
    },
    cWireCircle: {
        width: '20px',
        height: '20px',
        minWidth: '20px',
        borderRadius: '50%',
        border: '1px solid #01B5DE',
        backgroundColor: 'transparent',
        flexShrink: 0,
    },
    wiringChipTape: {
        padding: '5px 14px',
        borderRadius: '20px',
        border: `1px solid #BABEC3`,
        backgroundColor: 'transparent',
        color: '#BABEC3',
        ...fontClasses.body2,
        fontStyle: 'italic',
        minWidth: '60px',
        textAlign: 'center',
    },
    // Unused wire (UW) flow banners
    warningBanner: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px dashed #DE3C41',
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        gap: '8px',
        width: '100%',
    },
    warningBannerText: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'left',
    },
    infoBanner: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px dashed ${theme.palette.primary.dashedBorderColor || '#BABEC3'}`,
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        gap: '8px',
        width: '100%',
    },
    infoBannerText: {
        ...fontClasses.body1,
        color: `${theme.palette.secondary.subHeading} !important`,
        textAlign: 'left',
    },
    // Error screens (S3, S4, S5)
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 1 auto',
        paddingTop: '24px',
    },
    errorIcon: {
        marginBottom: '16px',
    },
    errorTitle: {
        ...fontClasses.title2,
        color: '#E02020',
        textAlign: 'center',
        fontWeight: '700',
        marginBottom: '12px',
    },
    errorBody: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        textAlign: 'center',
    },
    // LED error steps list
    stepsText: {
        ...fontClasses.body2,
    },
    powerPlate:{
        cursor: 'pointer',
        textdecoration: 'none',
        color: '#01B5DE'
    },
    // Setup complete success image wrapper
    successImageWrapper: {
        position: 'relative',
        display: 'inline-block',
        alignSelf: 'center'
    },
    successBadge: {
        position: 'absolute',
        top: '-6px',
        right: '-6px',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '18px',
    },
    // Terminal selection grouped grid
    terminalGroupsGrid: {
        display: 'grid',
        columnGap: '32px',
        gridTemplateColumns: '1fr 1fr',
        
        marginTop: '12px',
    },
    terminalGroupCard: {
        
    },
    terminalGroupCardFull: {
        gridColumn: 'span 2',
    },
    chipCircleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        background: `${theme.palette.primary.cardBackground}`,
        borderRadius: '4px',
        padding: '10px 4px',

    },
    chipCircleRowGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '10px',
        background: `${theme.palette.primary.cardBackground}`,
        borderRadius: '4px',
        padding: '10px 0',
    },
    chipCircleItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        gap: '4px',
        minWidth: '40px',
    },
    chipCircle: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: '1.5px solid #d0d0d0',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chipCircleSelected: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: `1.5px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chipCircleCheck: {
        color: '#fff',
        fontSize: '16px',
        fontWeight: '700',
        lineHeight: 0,
        '& path': {
            fill: '#fff',
        },
    },
    chipCircleLabel: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
        fontSize: '10px',
        textAlign: 'center',
        maxWidth: '52px',
        lineHeight: '1.2',
    },
    // Explanation screens (Learn more / Click here)
    learnMoreLink: {
        ...fontClasses.body1,
        color: '#01B5DE !important',
        textAlign: 'center',
        marginTop: '16px',
        cursor: 'pointer',
        textDecoration: 'none',
    },
    explainSubheading: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        fontWeight: '700',
        marginTop: '24px',
    },
    explainBody: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '4px',
    },
    explainCard: {
        backgroundColor: `${theme.palette.primary.cardBackground}`,
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        '& ul': {
            paddingLeft: '20px',
            margin: 0,
            listStyleType: 'disc',
        },
        '& li': {
            ...fontClasses.body1,
            color: `${theme.palette.tertiary.headingText} !important`,
            marginTop: '12px',
            textAlign: 'left',
            '&:first-child': {
                marginTop: 0,
            },
        },
    },
    dualFuelBanner: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px dashed ${theme.palette.primary.dashedBorderColor || '#BABEC3'}`,
        borderRadius: '8px',
        padding: '16px',
        marginTop: '16px',
        width: '100%',
    },
    dualFuelBannerText: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'left',
    },
    boldAccent: {
        fontWeight: '700',
        color: `${theme.palette.tertiary.headingText}`,
    },
    // Power Plate flow — wire color selection
    ppColorTable: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '16px',
    },
    ppColorTableHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 0',
        borderBottom: `1px solid ${theme.palette.primary.dashedBorderColor || '#E0E0E0'}`,
    },
    ppColorColLabel: {
        ...fontClasses.body2,
        color: `${theme.palette.secondary.subHeading} !important`,
        flex: 1,
    },
    ppColorRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 0',
        borderBottom: `1px solid ${theme.palette.primary.dashedBorderColor || '#E0E0E0'}`,
    },
    ppColorTerminal: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        flex: 1,
    },
    ppColorDropdown: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: 1,
        cursor: 'pointer',
        position: 'relative',
    },
    ppColorDot: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        flexShrink: 0,
        border: '1px solid #E0E0E0',
    },
    ppColorName: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        flex: 1,
    },
    ppColorPlaceholder: {
        ...fontClasses.body1,
        color: `${theme.palette.secondary.subHeading} !important`,
        flex: 1,
    },
    ppColorArrow: {
        fontSize: '12px',
        color: `${theme.palette.secondary.subHeading}`,
    },
    ppColorMenu: {
        position: 'absolute',
        top: '100%',
        right: 0,
        zIndex: 10,
        backgroundColor: `${theme.palette.primary.background}`,
        border: `1px solid ${theme.palette.primary.dashedBorderColor || '#E0E0E0'}`,
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxHeight: '200px',
        overflowY: 'auto',
        width: '180px',
        marginTop: '4px',
    },
    ppColorOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 12px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: `${theme.palette.primary.cardBackground}`,
        },
    },
    ppColorOptionText: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    // Power Plate flow — return screen bullet list (PP19)
    ppReturnBulletList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        marginTop: '8px',
        paddingLeft: '0',
    },
    ppReturnBulletItem: {
        ...fontClasses.body1,
        color: `${theme.palette.secondary.subHeading} !important`,
        textAlign: 'left',
        paddingLeft: '16px',
        position: 'relative',
        '&::before': {
            content: '"•"',
            position: 'absolute',
            left: '0',
            color: theme.palette.secondary.subHeading,
        },
    },
}));

export default makeStyle;
